module.exports = __webpack_public_path__ + "img/logomark-usage-example2.23a345b8.png";